module.exports = __webpack_public_path__ + "img/icon_favs_white.d32f816.svg";